/**
 * Section Label Component
 *
 * Small uppercase label for categorizing sections within lists or forms.
 * Commonly used for group headers in lists.
 *
 * @example
 * ```tsx
 * <SectionLabel>Popular Countries</SectionLabel>
 * ```
 */

import * as React from 'react';
import { cn } from '@/shared/utils/utils';

export interface SectionLabelProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children: React.ReactNode;
}

export const SectionLabel = React.forwardRef<HTMLParagraphElement, SectionLabelProps>(
  function SectionLabel({ className, children, ...props }, ref) {
    return (
      <p
        ref={ref}
        className={cn(
          'text-caption font-medium text-muted-foreground uppercase tracking-wide mb-2 px-4',
          className
        )}
        {...props}
      >
        {children}
      </p>
    );
  }
);
